var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStickyNoteLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 15.625L15.625 21.8708L4.16875 21.875C3.89321 21.8761 3.62851 21.7678 3.4328 21.5738C3.23709 21.3799 3.12638 21.1162 3.125 20.8406V4.15937C3.125 3.58854 3.58854 3.125 4.15937 3.125H20.8406C21.4115 3.125 21.875 3.6 21.875 4.16875V15.625V15.625ZM19.7917 5.20833H5.20833V19.7917H13.5417V14.5833C13.5417 14.3282 13.6354 14.0819 13.8049 13.8913C13.9745 13.7006 14.2081 13.5788 14.4615 13.549L14.5833 13.5417L19.7917 13.5406V5.20833ZM18.9281 15.624L15.625 15.625V18.926L18.9281 15.624Z",
    fill: "#2D2D2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNoteLine);
export default __webpack_public_path__ + "static/media/sticky-note-line.efb705d7.svg";
export { ForwardRef as ReactComponent };